import type { ReceivedBidV2Dto } from "../../../../autogen/bff-api";

export const bidDocuments = (bid: ReceivedBidV2Dto) =>
  [
    ...(bid.documents ?? []),
    ...((bid.qualificationResponses ?? []).flatMap((response) => response.evidenceDocuments ?? [])),
  ].filter((document, index, documents) => documents.findIndex((d) => d.id === document.id) === index);
